import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import icons from "../assets/images/sprite-other-icons.svg";

const Help = () => {
  const topRef = useRef(null);
  const location = useLocation();
  const { linksContent } = useSelector((state) => state?.footer);
  const navigate = useNavigate();

  const currentPath = location.pathname;
  const currentContent = linksContent?.find(
    (item) => item.menu_link === currentPath
  );

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  const goBack = () => {
    navigate("/");
  };

  return (
    <div className="SB-help" ref={topRef}>
      <div className="SB-pageHeader">
        <div className="SB-pageBackButton">
          <div className="SB-pageBackButton SB-iconSVG" onClick={goBack}>
            <svg xmlns="http://www.w3.org/2000/svg">
              <use xlinkHref={`${icons}#${"icon-back"}`} />
            </svg>
          </div>
        </div>
        <div className="SB-pageHeader-title">
          {currentContent?.link_name || "Content"}
        </div>
      </div>
      <div className="SB-help-content">
        {currentContent?.is_content && (
          <div
            dangerouslySetInnerHTML={{
              __html: currentContent.is_content,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Help;
